import type { ComponentProps } from 'react'

import { Toast } from '@base-ui/react'
import styled from 'styled-components'

const SnackbarTitle = styled.div`
	font-size: ${({ theme }) => theme.font.size.base};
	font-weight: 600;
	text-align: left;
`

type Props = ComponentProps<typeof Toast.Title>

export const Title = ({ ...rest }: Props) => <Toast.Title {...rest} render={(props) => <SnackbarTitle {...props} />} />
